import { render, staticRenderFns } from "./device_new.vue?vue&type=template&id=cc237d10&"
import script from "./device_new.vue?vue&type=script&lang=js&"
export * from "./device_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports